export const languageStringsSubscriptions = {
  title: "Előfizetés",
  successPayment: "A fizetés sikeres volt.",
  successPaymentDescription:
    "A kreditek pillanatokon belül megjelennek a fiókjában.",
  wantToChangeSubscription: "Valóban módosítani szeretné az előfizetését ",
  changeFrom: "erről: ",
  changeTo: " erre: ",
  subTitle: "Az Ön előfizetése",
  portableCreditsDescription:
    "Ezek a kreditek nem járnak le. Akkor kerülnek felhasználásra, ha túllépte a havi kreditkeretét.",
  tarifs: {
    title: "Díjcsomagok",
    monthly: "Havonta",
    yearly: "Évente",
    monthlyPeriod: "havi",
    yearlyPeriod: "éves",
    freeMonths: "2 hónap ingyen",
    viewsPerMonth: "megtekintések száma havonta",
    trial: "próbaverzió - korlátozások nélkül",
    creditsRefresh: "Kreditek megújítása: ",
    creditsExpire: "Kreditek lejárata: ",
    subbscription: "Előfizetés",
    trialVersion: "próbaverzió",
    trialVersionExpires: "A próbaverzió lejár",
    cancelSubscription: "Előfizetés megújításának törlése",
    nextPayment: "A következő fizetés automatikusan megtörténik",
    unlimitedVersion: "Az alkalmazás korlátlan verziója aktív",
    choseSubscription: "Díjcsomag kiválasztása",
    to: "Eddig",
    monthlyViews: "oldal megtekintés havonta",
    pricesAreFinal: "A feltüntetett árak véglegesek.",
    moreViews: "Még több havi megtekintéssel rendelkeznek oldalai?",
    contactUsForCustom:
      "Vegye fel velünk a kapcsolatot egyedi díjcsomag érdekében.",
    notificationsWithStatistics: "Értesítések látogatottsági statisztikákkal",
    notificationsWithLastOrdersAndRegistrations:
      "Értesítések az utolsó megrendelésekről és regisztrációkról",
    notificationPersonalization: "Értesítések személyre szabása",
    zboziAndHeureka: "Értesítések a Heureka és Zboží.cz értékelésekről",
    googleRecenze: "Integráció a Google értékelésekkel",
    trustPilot: "Integráció a Trustpilot-tal",
    logoCancel: "Logó eltávolítása",
    customBranding: "Egyedi arculat",
    unlimitedNotifications: "Korlátlan számú értesítés",
    unlimitedWebsites: "Korlátlan számú weboldal",
    onlyOneWebsite: "(csak 1 weboldal)",
    activateFreeTrial: "Ingyenes 14 napos próbaverzió aktiválása",
    mostFavorite: "Legnépszerűbb",
    selected: "Kiválasztva",
    notAvailable: "Nem elérhető",
    "LITE": {
      title: "LITE",
      priceYearly: "5 $",
      priceMonthly: "5 $",
    },
    "MEDIUM": {
      title: "MEDIUM",
      priceYearly: "20 $",
      priceMonthly: "20 $",
    },
    "UNLIMITED": {
      title: "UNLIMITED",
      priceYearly: "35 $",
      priceMonthly: "35 $",
    },
    lite: {
      title: "LITE",
      priceYearly: "39 Kč",
      priceMonthly: "47 Kč",
    },
    start: {
      title: "START",
      priceYearly: "247 Kč",
      priceMonthly: "297 Kč",
    },
    standard: {
      title: "STANDARD",
      priceYearly: "457 Kč",
      priceMonthly: "547 Kč",
    },
    premium: {
      title: "PREMIUM",
      priceYearly: "833 Kč",
      priceMonthly: "997 Kč",
    },
  },
};
